import { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import TextField from "../../../ui/TextField";
import RangeField from "../../../ui/RangeField";
import CheckboxGroup from "../../../ui/CheckboxGroup";
import SearchCondition from "../../../features/SearchCondition";
import Button from "../../../ui/Button";
import Summary from "../../../ui/Summary";
import styles from "../../../layout/admin/Main.module.scss";
import { getCodeMasterList } from "../../../../services/apiCodeMaster";
import { validateMaxlength } from "../../../../utils/validate";

const approvalValueApproved = 1; //承認ステータス_承認

const SearchForm = ({ setSearchCondition }) => {
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm();

  // 承認ステータスチェックボックス
  const [approvalElements, setApprovalElements] = useState([]);
  // 学生区分チェックボックス
  const [stTypeElements, setStTypeElements] = useState([]);

  //初回レンダリング
  useEffect(() => {
    (async function () {
      const apData = await getCodeMasterList({ code: "CD002" });
      const stData = await getCodeMasterList({ code: "CD009" });
      if (!apData || !stData) return;
      // 承認状況
      setApprovalElements(
        apData.map((d) => {
          let defalt_check = false;
          if (d.d_value === approvalValueApproved) {
            //初期表示で承認済みをチェックする
            defalt_check = true;
          }
          return {
            label: d.d_text,
            value: d.d_value,
            defalt_check: defalt_check,
          };
        })
      );
      // 学生区分
      setStTypeElements(
        stData.map((d) => {
          return {
            label: d.d_text,
            value: d.d_value,
            defalt_check: false,
          };
        })
      );
    })();
  }, []);

  //検索結果の表示
  const onSubmit = (data) => {
    setSearchCondition(data);
  };

  const resetCondition = () => {
    setValue("login_id", "");
    setValue("generation_id", "");
    setValue("name", "");
    setValue("name_kana", "");
    setValue("street_name1", "");
    setValue("street_name2", "");
    setValue("birthday_s", "");
    setValue("birthday_e", "");
    setValue("approval_status_0", false);
    setValue("approval_status_1", true);
    setValue("approval_status_2", false);
    setValue("student_type_1", false);
    setValue("student_type_2", false);
  };

  return (
    <div>
      <details open>
        <Summary />
        <form onSubmit={handleSubmit(onSubmit)}>
          <SearchCondition title="学生を絞り込む">
            <table className={styles.formtable}>
              <tr>
                <TextField
                  register={register}
                  name="login_id"
                  errors={errors}
                  label="学生番号(8桁)"
                  placeholder="学生番号(8桁)"
                  validation={{ ...validateMaxlength(8) }}
                ></TextField>
              </tr>
              <tr>
                <TextField
                  register={register}
                  name="generation_id"
                  errors={errors}
                  label="期生ID(入学年月)"
                  placeholder="期生ID(入学年月)"
                  validation={{ ...validateMaxlength(4) }}
                ></TextField>
              </tr>
              <tr>
                <TextField
                  register={register}
                  name="name"
                  errors={errors}
                  label="氏名"
                  placeholder="氏名"
                  validation={{ ...validateMaxlength(100) }}
                ></TextField>
              </tr>
              <tr>
                <TextField
                  register={register}
                  name="name_kana"
                  errors={errors}
                  label="フリガナ"
                  placeholder="フリガナ"
                  validation={{ ...validateMaxlength(100) }}
                ></TextField>
              </tr>
              <tr>
                <TextField
                  register={register}
                  name="street_name1"
                  errors={errors}
                  label="町名"
                  placeholder="町名"
                  validation={{ ...validateMaxlength(100) }}
                ></TextField>
              </tr>
              <tr>
                <TextField
                  register={register}
                  name="street_name2"
                  errors={errors}
                  label="丁名"
                  placeholder="丁名"
                  validation={{ ...validateMaxlength(100) }}
                ></TextField>
              </tr>
              <tr>
                <CheckboxGroup
                  errors={errors}
                  register={register}
                  label="承認状況"
                  name="approval_status"
                  elements={approvalElements}
                />
              </tr>
              <tr>
                <CheckboxGroup
                  errors={errors}
                  register={register}
                  label="学生区分"
                  name="student_type"
                  elements={stTypeElements}
                />
              </tr>
              <tr>
                <RangeField
                  register={register}
                  nameFrom={"birthday_s"}
                  nameTo={"birthday_e"}
                  errors={errors}
                  label="生年月日"
                ></RangeField>
              </tr>
            </table>

            {errors.exampleRequired && <span>This field is required</span>}
          </SearchCondition>
          <div className={styles.buttonbox}>
            <Button type="submit" styleType="search">
              検索
            </Button>
            <Button
              type="button"
              styleType="back"
              onClick={() => resetCondition()}
            >
              条件クリア
            </Button>
          </div>
        </form>
      </details>
    </div>
  );
};

export default SearchForm;
